/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useContext, useState} from 'react';
import { Outlet } from 'react-router-dom'
import UpdatePassword from '../UpdatePassword'
import SideBar from './Sidebar'
import { useSelector } from 'react-redux';
import GlobalContext from '../Context/GloablContext';

export default function Layout() {
    const auth = useSelector(state => state.auth);
    const {userType} = auth
    const {isInactiveBranch, isBranchSpecifTab}= useContext(GlobalContext);

    return (
        <>
            <div  className='bg-[#FFFFFF] fixed w-full'>
                <UpdatePassword />
                <div className="flex">
                    <SideBar role={userType}/>
                    {isInactiveBranch && !isBranchSpecifTab && <div class="inactvmsg">This branch is currently inactive</div>}
                    <Outlet />
                </div>
            </div>
        </>
        
    )
}
